
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGlobalContext } from '../context/GlobalContext';

const Data = () => {
  const { siteInfo, currentLang, loading, error } = useGlobalContext();
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="text-center">
        <p>{t('Chargement...')}</p>
      </div>
    );
  }

  if (error || !siteInfo) {
    return (
      <div className="text-center">
        <p>{t('Une erreur est survenue')}</p>
      </div>
    );
  }

  const personalInfosData = siteInfo.personalInfos?.[currentLang];

  if (!personalInfosData) {
    return (
      <div className="text-center">
        <p>{t('Informations de protection des données non disponibles pour cette langue.')}</p>
      </div>
    );
  }

  return (
    <div id="data">
      <header>
        <h1 className="sr-only">Data Overview</h1>
        <h2 className="sr-only">Data Overview</h2>
      </header>
      <div dangerouslySetInnerHTML={{ __html: personalInfosData }} />
    </div>
  );
};

export default Data;